/**
 * @desc 会员中心: 更新角色
 */
import { MemberRoleForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateMemberRoleParameter = MemberRoleForm

const method = 'PUT'
const url = '/auth/member/role'

export const updateMemberRoleApi = (
  data?: UpdateMemberRoleParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

updateMemberRoleApi.method = method
updateMemberRoleApi.url = url
